import useMediaQuery from './media-query';

export default useMediaQuery;
